import Amplify from "aws-amplify";
import getConfig from "./config";

const cfg = getConfig();

function createAWSConfig() {
  return {
    // authentication configuration
    Auth: {
      mandatorySignIn: true,
      region: cfg.cognito.REGION,
      userPoolId: cfg.cognito.USER_POOL_ID,
      userPoolWebClientId: cfg.cognito.APP_CLIENT_ID,
      identityPoolId: cfg.cognito.IDENTITY_POOL_ID,
    },
  };
}

// Configure AWS Amplify
export function amplifyConfigure() {
  // configure Amplify
  Amplify.configure(createAWSConfig());
}
